import { Observable } from "@reactivex/rxjs";

/** contract for store changes */
export interface StoreChangeDetails {
  /** reason for store change event */
  readonly reason: string;

  /** entity type name */
  readonly entityType: string;

  /** data associated with the change event */
  data?: {};

  /** error associated to the change */
  error?: {};
}

/** interface provides context for getting the value */
export interface ValueContext<T> {
  /** reason for value context */
  readonly reason: string;

  /** Observable provides value */
  valueObservable: () => Observable<T>;
}

/** Store interface provides creation of items and exposes changes to store as observables.  */
export interface Store<T> {
  /** Entity type */
  readonly entityType: string;

  /** Entity value as observable */
  getChangesAsObservable(): Observable<StoreChangeDetails>;

  /**
   * Provides an container for a given key, creates one if not present
   * @param {string} key - Key for the container.
   * @param {ValueContext} - default value provider
   */
  getOrAddValueContainer(key: string, defaultValueContext?: ValueContext<T>): StoreValueContainer<T>;
}

/**Strongly typed container for entity */
export interface StoreValueContainer<T> {
  /** Entity type. */
  readonly entityType: string;

  /** Key identifier. */
  readonly key: string;

  /** Last update date. */
  readonly lastUpdated: Date;

  /** Additional properties to be stored. */
  readonly additionalProperties: Map<string, string>;

  /** Entity value as observable. */
  asObservable(): Observable<T>;

  /** Set entity value provided by value context. */
  setValue(context: ValueContext<T>): void;
}

class Placeholder {
  // BUGBUG: this file breaks Karma w/ odd blank SourceMap files
  // So creating blank class to emit some code
}
